import { useEffect, useRef } from "react";
const AUTH_DOMAIN = import.meta.env.VITE_BETA_ENV
  ? "https://beta-app.undesk.com.br"
  : "https://app.undesk.com.br"; 

const AuthRedirect = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== AUTH_DOMAIN) return;

      if (event.data?.status === "iframeReady") {
        iframeRef.current?.contentWindow?.postMessage(
          { action: "checkAuth" },
          { targetOrigin: AUTH_DOMAIN }
        );
      }

      if (event.data?.isAuthenticated) {
        window.location.href = `${AUTH_DOMAIN}/profile`;
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={`${AUTH_DOMAIN}/check-auth`}
      style={{ display: "none" }}
      title="auth-checker"
    />
  );
};

export default AuthRedirect;